/**
 * Returns the boolean if the Gift Card pin should be  shown per configs
 * @param {string} gcNumber
 * @returns {boolean}
 */

export const showGiftCardPin = (gcNumber: string) => {
  const { giftCard: { minDigitsForPin, showPin } } = useAppConfig().checkout
  return !showPin?.requiredLocales.includes(useLocale()) ? gcNumber.length > minDigitsForPin : true
}
